// Centralized authority level definitions
// Used by rag_utils.js, searchUtils.js, ChatMessages.js, and any other file that needs authority display info.
// UPDATE THIS FILE when adding new authority levels — do NOT duplicate these mappings elsewhere.

export const AUTHORITY_LEVELS = {
  'legal_interpretations': { name: 'LEGAL INT', emoji: '⚖️', rank: 1 },
  'code_and_regulations': { name: 'CODE/REG', emoji: '📘', rank: 2 },
  'revenue_rulings': { name: 'REV RUL', emoji: '📜', rank: 3 },
  'revenue_procedures': { name: 'REV PROC', emoji: '📄', rank: 4 },
  'private_letter_rulings': { name: 'PLR', emoji: '💌', rank: 5 },
  'secondary_authorities': { name: 'SECONDARY', emoji: '📚', rank: 6 },
  'state_tax_language': { name: 'STATE TAX', emoji: '🗺️', rank: 7 },
  'rules_for_reviewing': { name: 'RULES', emoji: '📋', rank: 8 },
  'other_authorities': { name: 'OTHER', emoji: '🔎', rank: 9 },
  // Legacy mappings for backward compatibility
  'internal_revenue_code': { name: 'IRC', emoji: '🏛️', rank: 2 },
  'treasury_regulations': { name: 'TREAS', emoji: '📋', rank: 2 },
  'cases': { name: 'CASE', emoji: '⚖️', rank: 3 }
};

export const getAuthorityInfo = (authorityLevel) => {
  return AUTHORITY_LEVELS[authorityLevel] || { name: 'OTHER', emoji: '📎', rank: 99 };
};

export const getAuthorityDisplayName = (authorityLevel) => {
  const info = getAuthorityInfo(authorityLevel);
  return info.name;
};

// Full display names for UI labels (DocumentViewer, headers, etc.)
// Single source of truth — do not duplicate this mapping elsewhere.
export const COLLECTION_LABELS = {
  code_and_regulations: 'Code & Regulations',
  revenue_rulings: 'Revenue Rulings',
  revenue_procedures: 'Revenue Procedures',
  private_letter_rulings: 'Private Letter Rulings',
  secondary_authorities: 'Secondary Authorities',
  legal_interpretations: 'Legal Interpretations',
  other_authorities: 'Other Authorities',
  state_tax_language: 'State Tax Language',
  rules_for_reviewing: 'Review Rules',
};
